import React from 'react';
import './styles.css';

const Box = ({ children }) => <section className="Box">{children}</section>;

export default Box;



/** WEBPACK FOOTER **
 ** ./src/views/components/box/index.js
 **/